import React from "react";
import styles from "../styles/PageLayout.module.css";

export function PageContent({ children }) {
  return <div className={styles.pageContent}>{children}</div>;
}

export default PageContent;
